import { AlignmentStatus } from '../../jscaip/AI/AlignmentHeuristic';
import { Heuristic } from '../../jscaip/AI/Heuristic';
import { CoordSet } from '../../jscaip/CoordSet';
import { QuartoRules } from './QuartoRules';
export class QuartoHeuristic extends Heuristic {
    getBoardValue(node, config) {
        const state = node.gameState;
        let boardStatus = {
            status: AlignmentStatus.NOTHING,
            sensitiveSquares: new CoordSet(),
        };
        const maxLevel = Math.max(config.playerZeroLevel, config.playerOneLevel);
        const patterns = QuartoRules.get().getPatterns(maxLevel, state);
        for (const pattern of patterns) {
            boardStatus = QuartoRules.get().updateBoardStatus(pattern, state, boardStatus).boardStatus;
        }
        return boardStatus.status.toBoardValue(state.turn);
    }
}
